import updateTree from './updateTree'

export default function earningsStatement(state = {}, action) {
  switch (action.type) {
    case 'SET_EARNINGS_STATEMENT': {
      return updateTree(state, 'prop22EarningsStatement', () => action.earningsStatement)
    }

    case 'SET_SEATTLE_EARNINGS_STATEMENT': {
      return updateTree(state, 'seattleEarningsStatement', () => action.earningsStatement)
    }

    case 'SET_NYC_EARNINGS_STATEMENT': {
      return updateTree(state, 'nycEarningsStatement', () => action.earningsStatement)
    }

    default:
      return {
        prop22EarningsStatement: [],
        seattleEarningsStatement: [],
        nycEarningsStatement: [],
        ...state,
      }
  }
}
